// removed by extract-text-webpack-plugin
module.exports = {"paginationWrapper":"sXNga","pagination":"_2GLQn","firstLastPage":"_1d0TB","active":"CBW9l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/Pagination.scss
// module id = 2596
// module chunks = 0